/**
 * HTTP header validation utilities
 * @module validation/http-header
 */

const PRINTABLE_ASCII = /^[\x20-\x7E]+$/;

/** True when a header value is non-empty and only printable ASCII (U+0020–U+007E). */
export function isValidHttpHeaderValue(value: string): boolean {
  return PRINTABLE_ASCII.test(value);
}
